import React from "react";

import { UserInfoQuestions } from "consts";
import { useConsentQuestion } from "screens/question/hooks";

import { Container, Checkbox, CheckMarkImage, Label } from "./styled";

export const ConsentQuestion = ({ question, section }) => {
  const { isSelected, onPress, RTL } = useConsentQuestion(question);

  const isUserInfoScreen = section.questions.some(
    q => UserInfoQuestions[q.app_screen_type],
  );

  return (
    <Container $RTL={RTL} onPress={onPress} $fullWidth={!isUserInfoScreen}>
      <Checkbox $isSelected={isSelected}>
        <CheckMarkImage
          $isSelected={isSelected}
          source={require("assets/images/check-mark.png")}
        />
      </Checkbox>
      <Label $RTL={RTL} $isSelected={isSelected}>
        {question.text}
      </Label>
    </Container>
  );
};
